

import React, { memo } from 'react';
import { NavModal, Text } from '../../../../../ui-kit';



import '../styles/_private-settings-modal.scss';









function PrivateSettings(
{
  visible,
  privateResource,
  handleUpdate,
  hideModal,
  resourceName
}) {
  const resourceStr = resourceName === 'Video' ? 'project' : resourceName;
  const subtitle = privateResource ?
  `By setting the project as ‘public’, everyone within your Organisation will be able to view and access your ${resourceStr}.` :
  `By setting the project as ‘private’, only you and invited project collaborators will be able to view and access your ${resourceStr}.`;

  return (
    <NavModal
      visible={visible}
      title="Are you sure?"
      primaryAction={handleUpdate}
      secondaryAction={hideModal}
      onClose={hideModal}
      primaryText="Yes I'm sure"
      secondaryText="Cancel"
      alignActionBtnsToEnd
      hideIcon
      className="private-settings-modal">

      <Text>{subtitle}</Text>
    </NavModal>);

}

export default memo(PrivateSettings);